<template>
  <div class="card">
    <div class="card-header border-bottom">
      <h4 class="mb-0">Recent Updates</h4>
    </div>
    <div v-for="post in posts" :key="post.id">
      <div class="card-header d-flex align-items-center">
        <div class="d-flex align-items-center">
          <a href="#">
            <img :src="post.author.avatarUrl" class="avatar" />
          </a>
          <div class="mx-3">
            <a href="#" class="text-dark font-weight-600 text-sm">{{post.author.displayName}}</a>
            <small class="d-block text-muted">{{moment(post.posted).fromNow()}}</small>
          </div>
        </div>
      </div>
      <div class="card-body border-bottom">
        <p
          class="mb-4"
        >{{post.body}}</p>
        <img alt="Image placeholder" :src="post.imageUrl" class="img-fluid rounded" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "activity-feed",
  data() {
    return {
      posts: []
    };
  },
  methods: {
    loadData() {
      this.axios
        .get(`Announcements`)
        .then(data => this.posts.push(...data.data));
    }
  },
  created() {
    this.loadData();
  }
};
</script>
<style>
</style>
